module.exports = __webpack_public_path__ + "static/media/295344.8718fed7.png";